import { render, staticRenderFns } from "./DataTableMenu.vue?vue&type=template&id=bc4c9b6c&scoped=true&"
import script from "./DataTableMenu.vue?vue&type=script&lang=js&"
export * from "./DataTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4c9b6c",
  null
  
)

export default component.exports